import { render, staticRenderFns } from "./GenderIcon.vue?vue&type=template&id=4dbe59b5&scoped=true&"
import script from "./GenderIcon.vue?vue&type=script&lang=js&"
export * from "./GenderIcon.vue?vue&type=script&lang=js&"
import style0 from "./GenderIcon.vue?vue&type=style&index=0&id=4dbe59b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe59b5",
  null
  
)

export default component.exports